import React from "react";
import { compose } from "redux";
import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";

const styles = () => ({
  labelRoot: {
    fontSize: "12px"
  }
});

const EditablePresetWrapper = styled.div`
    padding: 1em;
    background-color: white;
    border-bottom: 1px solid #DADCE0;
`;

const StyledTextField = styled(TextField)`
    width: 100%;
`;

const EditablePreset = ({ selectedPreset, setNewPresetName, setSelectedPreset, newPreset = false, classes }) => {
  const { id, name, body } = selectedPreset;

  return (
    <EditablePresetWrapper>
      <StyledTextField
        InputLabelProps={{
          FormLabelClasses: {
            root: classes.labelRoot
          }
        }}
        label={"Preset Name"}
        value={newPreset ? selectedPreset : name}
        onChange={e => (newPreset ? setNewPresetName(e.target.value) : setSelectedPreset({ name: e.target.value, id, body }))}
      />
    </EditablePresetWrapper>
  );
};

export default compose(withStyles(styles))(EditablePreset);
